const enums = {
  DIY: { text: 'DIY产品', value: 2 },
  SIMPLE: { text: '一般产品', value: 1 },
  SDS: { text: 'SDS产品', value: 3 }
}
export default enums
